/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import LoginUserCompany from './LoginUserCompany';
import LoginUserDeliveryGroup from './LoginUserDeliveryGroup';
import LoginUserGroup from './LoginUserGroup';

/**
* The LoginUser model module.
* @module model/LoginUser
* @version 2020-12-7
*/
export default class LoginUser {
    /**
    * Constructs a new <code>LoginUser</code>.
    * @alias module:model/LoginUser
    * @class
    * @param company {module:model/LoginUserCompany} 
    * @param id {Number} ユーザーID
    * @param name {String} ユーザー名
    * @param loginId {String} ログインID
    * @param companyId {Number} 会社ID
    * @param groupId {Number} グループID
    * @param roleId {Number} ロールID
    * @param authorities {Array.<String>} 権限
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(company, id, name, loginId, companyId, groupId, roleId, authorities, updatedAt) {
        
        
        this['company'] = company;
        this['id'] = id;
        this['name'] = name;
        this['loginId'] = loginId;
        this['companyId'] = companyId;
        this['groupId'] = groupId;
        this['roleId'] = roleId;
        this['authorities'] = authorities;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>LoginUser</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoginUser} obj Optional instance to populate.
    * @return {module:model/LoginUser} The populated <code>LoginUser</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoginUser();
                        
            
            if (data.hasOwnProperty('company')) {
                obj['company'] = LoginUserCompany.constructFromObject(data['company']);
            }
            if (data.hasOwnProperty('group')) {
                obj['group'] = LoginUserGroup.constructFromObject(data['group']);
            }
            if (data.hasOwnProperty('deliveryGroup')) {
                obj['deliveryGroup'] = LoginUserDeliveryGroup.constructFromObject(data['deliveryGroup']);
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('loginId')) {
                obj['loginId'] = ApiClient.convertToType(data['loginId'], 'String');
            }
            if (data.hasOwnProperty('companyId')) {
                obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Number');
            }
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('authorities')) {
                obj['authorities'] = ApiClient.convertToType(data['authorities'], ['String']);
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/LoginUserCompany} company
    */
    'company' = undefined;
    /**
    * @member {module:model/LoginUserGroup} group
    */
    'group' = undefined;
    /**
    * @member {module:model/LoginUserDeliveryGroup} deliveryGroup
    */
    'deliveryGroup' = undefined;
    /**
    * ユーザーID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * ユーザー名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * ログインID
    * @member {String} loginId
    */
    'loginId' = undefined;
    /**
    * 会社ID
    * @member {Number} companyId
    */
    'companyId' = undefined;
    /**
    * グループID
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * 配送グループID
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * ロールID
    * @member {Number} roleId
    */
    'roleId' = undefined;
    /**
    * 権限
    * @member {Array.<String>} authorities
    */
    'authorities' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
